// extracted by mini-css-extract-plugin
export var faExclamationCircle = "WarningBanner_faExclamationCircle__fZzy0";
export var icon = "WarningBanner_icon__D8nLq";
export var message = "WarningBanner_message__rGxSs";
export var subtitle = "WarningBanner_subtitle__ZZm1q";
export var title = "WarningBanner_title__dNfb2";
export var wbContainer = "WarningBanner_wbContainer__flx0T";